import React from "react";
import { Table } from "antd";

export default function ServiceAndCardTab() {
    // 1. Dữ liệu Bảng Dịch vụ đã làm
    const serviceData = [
        {
            key: "1",
            date: "20/12/2025",
            category: "Clinic",
            service: "Phác đồ K·Reskin · Basic · buổi trải nghiệm",
            session: "1/1",
            performer: "KTV-03",
            value: "6.000.000 đ",
            payment: "Đã đủ",
        },
    ];

    const serviceColumns = [
        { title: "Ngày", dataIndex: "date", key: "date", width: "15%" },
        { title: "Mảng", dataIndex: "category", key: "category", width: "12%" },
        { title: "Gói / dịch vụ", dataIndex: "service", key: "service", width: "35%", render: (text: string) => <span className="font-semibold text-gray-900 dark:text-gray-100">{text}</span> },
        { title: "Buổi", dataIndex: "session", key: "session", width: "10%" },
        { title: "Người thực hiện", dataIndex: "performer", key: "performer", width: "15%" },
        { title: "Giá trị", dataIndex: "value", key: "value", width: "13%" },
        { title: "Thanh toán", dataIndex: "payment", key: "payment", width: "12%" },
    ];

    // 2. Dữ liệu Bảng Sản phẩm mang về (Homecare)
    const homecareData = [
        {
            key: "1",
            date: "20/12/2025",
            product: "Kem chống nắng (Homecare Clinic)",
            quantity: 2,
        },
    ];

    const homecareColumns = [
        { title: "Ngày", dataIndex: "date", key: "date", width: "25%" },
        { title: "Sản phẩm", dataIndex: "product", key: "product", width: "55%", render: (text: string) => <span className="font-medium text-gray-800 dark:text-gray-200">{text}</span> },
        { title: "Số lượng", dataIndex: "quantity", key: "quantity", width: "20%" },
    ];

    // 3. Dữ liệu Bảng Mốc tái khám
    const followupData = [
        {
            key: "1",
            milestone: "T+7 tái khám",
            expectedDate: "27/12/2025",
            status: "Đã tái khám (03/01/2026, dời)",
            statusType: "success",
        },
        {
            key: "2",
            milestone: "T+30 gợi ý buổi tiếp",
            expectedDate: "19/01/2026",
            status: "Quá hạn (khách đã về Úc)",
            statusType: "danger",
        },
    ];

    const followupColumns = [
        { title: "Mốc", dataIndex: "milestone", key: "milestone", width: "35%", render: (text: string) => <span className="font-medium text-gray-800 dark:text-gray-200">{text}</span> },
        { title: "Ngày dự kiến", dataIndex: "expectedDate", key: "expectedDate", width: "30%" },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            width: "35%",
            render: (text: string, record: any) => {
                const colorClass = record.statusType === "success" 
                    ? "text-green-700 font-bold dark:text-green-400" 
                    : "text-red-600 font-bold dark:text-red-400";
                return <span className={colorClass}>{text}</span>;
            },
        },
    ];

    return (
        <div className="space-y-4 pt-1 text-xs animate-fade-in text-gray-800 dark:text-gray-200">
            
            {/* Khối 1: Dịch vụ đã làm */}
            <div className="space-y-1.5">
                <div className="font-bold text-[#1d4c7d] dark:text-blue-400 text-sm">Dịch vụ đã làm</div>
                <div className="border border-[#3E91AB]/30 rounded overflow-hidden">
                    <Table
                        dataSource={serviceData}
                        columns={serviceColumns}
                        pagination={false}
                        size="small"
                        className="custom-[#3E91AB]-table"
                        scroll={{ x: "max-content" }}
                    />
                </div>
            </div>

            {/* Khối 2: Thẻ liệu trình */}
            <div className="space-y-1">
                <div className="font-bold text-[#1d4c7d] dark:text-blue-400 text-sm">Thẻ liệu trình</div>
                <div className="text-gray-500 italic">Không có thẻ liệu trình.</div>
            </div>

            {/* Khối 3: Sản phẩm mang về (Homecare) */}
            <div className="space-y-1.5">
                <div className="font-bold text-[#1d4c7d] dark:text-blue-400 text-sm">Sản phẩm mang về (Homecare)</div>
                <div className="border border-[#3E91AB]/30 rounded overflow-hidden">
                    <Table
                        dataSource={homecareData}
                        columns={homecareColumns}
                        pagination={false}
                        size="small"
                        className="custom-[#3E91AB]-table"
                        scroll={{ x: "max-content" }}
                    />
                </div>
            </div>

            {/* Khối 4: Chi tiêu */}
            <div className="space-y-1.5 pt-1">
                <div className="font-bold text-[#1d4c7d] dark:text-blue-400 text-sm">Chi tiêu</div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 max-w-md text-xs">
                    <div className="flex justify-between py-0.5">
                        <span className="text-gray-500">Tổng chi tiêu</span>
                        <span className="font-bold text-gray-900 dark:text-gray-100">7.000.000 đ</span>
                    </div>
                    <div className="flex justify-between py-0.5">
                        <span className="text-gray-500">Số lần dùng dịch vụ</span>
                        <span className="font-medium">1</span>
                    </div>
                    <div className="flex justify-between py-0.5">
                        <span className="text-gray-500">Số đơn mua</span>
                        <span className="font-medium">1</span>
                    </div>
                    <div className="flex justify-between py-0.5">
                        <span className="text-gray-500">Giá trị đơn trung bình</span>
                        <span className="font-medium">7.000.000 đ</span>
                    </div>
                    <div className="flex justify-between py-0.5">
                        <span className="text-gray-500">Lần gần nhất</span>
                        <span className="font-medium">20/12/2025</span>
                    </div>
                    <div className="flex justify-between py-0.5 items-center">
                        <span className="text-gray-500">Hạng chi tiêu</span>
                        <div className="flex items-center gap-1">
                            <span className="font-bold text-gray-900 dark:text-gray-100">B</span>
                            <span className="bg-[#d97706] text-white text-[10px] px-1.5 py-0.2 rounded font-bold cursor-pointer">[?] quy tắc xếp hạng</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Khối 5: Mốc tái khám */}
            <div className="space-y-1.5 pt-1">
                <div className="font-bold text-[#1d4c7d] dark:text-blue-400 text-sm">Mốc tái khám</div>
                <div className="border border-[#3E91AB]/30 rounded overflow-hidden">
                    <Table
                        dataSource={followupData}
                        columns={followupColumns}
                        pagination={false}
                        size="small"
                        className="custom-[#3E91AB]-table"
                        scroll={{ x: "max-content" }}
                        rowClassName={(record, index) => 
                            index % 2 === 1 
                                ? "bg-slate-50/80 dark:bg-[#252525]" 
                                : "bg-white dark:bg-[#1f1f1f]"
                        }
                    />
                </div>
            </div>
        </div>
    );
}